<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        :btitle="'Sip Digitmap'"
        :collapseStatus="'close'"
        style="height: 100%"
      >
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkEdit()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <!--显示列表-->
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllDigitmap"
                />
                <label for="idSelectAllDigitmap"></label>
              </th>
              <th
                v-for="(value, key) in uniqueSipDigitmap.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in uniqueSipDigitmap.data"
              :key="row.dialPlanId"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectSipDigitmap' + index"
                  />
                  <label :for="'idRowSelectSipDigitmap' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.dialPlanId }}</div>
              </td>
              <td>
                <div>{{ row.dialPlanToken }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Sip Digitmap Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="dialPlanId"
                  >Dial PlanID</label
                >
                <div
                  class="col-sm-6"
                  :class="{
                    'has-error': checkParameters(
                      'id',
                      sipDigitmapForm.dialPlanId
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="dialPlanId"
                    v-model="sipDigitmapForm.dialPlanId"
                    placeholder="INTEGER<1-10>"
                    :disabled="isEditClik"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters('id', sipDigitmapForm.dialPlanId)
                        ? 'block'
                        : 'none',
                    }"
                    >{{ checkParameters("id", sipDigitmapForm.dialPlanId) }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="dialPlanToken"
                  >Dial Plan Token</label
                >
                <div
                  class="col-sm-6"
                  :class="{
                    'has-error': checkParameters(
                      'token',
                      sipDigitmapForm.dialPlanToken
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="dialPlanToken"
                    v-model="sipDigitmapForm.dialPlanToken"
                    placeholder="STRING<1-28>  such as: [1-7]xxxxxxxxx#"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'token',
                        sipDigitmapForm.dialPlanToken
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("token", sipDigitmapForm.dialPlanToken)
                    }}
                  </small>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "uniqueSipDigitmap",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["ontIndex"],

  data() {
    return {
      uniqueSipDigitmap: "",
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      sipDigitmapForm: {
        dialPlanId: "",
        dialPlanToken: "",
      },
    }
  },

  created() {
    this.loaduniqueSipDigitmap()
  },

  methods: {
    loaduniqueSipDigitmap() {
      get("uniqueSipDigitmap?ontIndex=" + this.ontIndex)
        .then((res) => (this.uniqueSipDigitmap = res.data))
        .catch((err) => {})
    },

    clkAdd() {
      this.isShowAddTable = true
      this.isEditClik = false
      this.resetField()
      this.selectNull()
    },
    clkEdit() {
      for (let i = 0; i < this.uniqueSipDigitmap.data.length; i++) {
        if (this.uniqueSipDigitmap.data[i].selected) {
          this.sipDigitmapForm.dialPlanId =
            this.uniqueSipDigitmap.data[i].dialPlanId
          this.sipDigitmapForm.dialPlanToken =
            this.uniqueSipDigitmap.data[i].dialPlanToken
          this.isShowAddTable = true
          this.isEditClik = true
          return
        }
      }
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.uniqueSipDigitmap.data.length; i++) {
        if (this.uniqueSipDigitmap.data[i].selected) {
          list.push({ id: Number(this.uniqueSipDigitmap.data[i].dialPlanId) })
        }
      }
      if (list.length == 0) {
        return
      }

      delData["dialPlanId"] = list
      delData["ontIndex"] = this.ontIndex
      post("uniqueSipDigitmapDelete", delData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueSipDigitmap()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else {
            this.loaduniqueSipDigitmap()
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var sipDigitmapFormTmp = {
        dialPlanId: "",
        dialPlanToken: "",
      }
      this.sipDigitmapForm = sipDigitmapFormTmp
    },
    changeSelectAll() {
      for (let i = 0; i < this.uniqueSipDigitmap.data.length; i++) {
        if (this.isSelectAll) {
          this.uniqueSipDigitmap.data[i].selected = true
        } else {
          this.uniqueSipDigitmap.data[i].selected = false
        }
      }
    },

    selectNull() {
      for (let i = 0; i < this.uniqueSipDigitmap.data.length; i++) {
        this.uniqueSipDigitmap.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var sipDigitmapConfig = {
        ontIndex: this.ontIndex,
        dialPlanId: Number(this.sipDigitmapForm.dialPlanId),
        dialPlanToken: this.sipDigitmapForm.dialPlanToken,
      }
      if (this.isEditClik == false) {
        for (let i = 0; i < this.uniqueSipDigitmap.data.length; i++) {
          if (
            sipDigitmapConfig.dialPlanId ==
            this.uniqueSipDigitmap.data[i].dialPlanId
          ) {
            this.showAlertBox(
              "warn",
              "Message",
              "This dial plan ID has been created"
            )
            return
          }
        }
      }

      if (
        this.sipDigitmapForm.dialPlanId == "" ||
        this.sipDigitmapForm.dialPlanToken == "" ||
        this.checkParameters("id", this.sipDigitmapForm.dialPlanId) ||
        this.checkParameters("token", this.sipDigitmapForm.dialPlanToken)
      ) {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }

      post("uniqueSipDigitmapConfig", sipDigitmapConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loaduniqueSipDigitmap()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.isEditClik = false
      this.selectNull()
    },
    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "id") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 10) {
          return "dial plan ID must be in range 1-10"
        }
      } else if (type == "token") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 28
        ) {
          return "invalid token"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
